// The scrim that draws a halt on the player's own surface.
//
// T12 of docs/plans/2026-09-07-verification-overlay.md. Its own module, and
// deliberately a LEAF — it imports the theme tokens and nothing else — because
// `player/VideoPlayer.tsx` is what renders it, and the player must not learn
// what verification is. It is handed a boolean it already has (`halted`) and
// returns a style; it knows nothing about chains, seals or ledgers.
//
// Pure, and therefore tested: "cuts rather than eases under reduced motion" is
// an acceptance criterion, and a `.tsx` test would not be collected here (see
// the plan's Testing note).
import { color, motion } from './verificationTheme.js'

/** How dark the surface goes behind the panel. Not fully opaque: the last
 * frame we could not vouch for stays faintly visible, because the video did
 * not disappear — we stopped being able to check it. */
export const SCRIM_OPACITY = 0.92

export interface ScrimStyle {
  backgroundColor: string
  opacity: number
  /** Absent under reduced motion, and only then: the scrim CUTS to full
   * rather than easing, which is the acceptance criterion. */
  transition?: string
}

/**
 * The scrim behind the panel. `visible` is flipped one frame after the halt so
 * the browser has an initial opacity to ease away from; under reduced motion
 * there is no transition at all, so the same flip lands as a cut.
 */
export function failureScrimStyle(opts: { visible: boolean; reducedMotion: boolean }): ScrimStyle {
  const style: ScrimStyle = {
    backgroundColor: color.ink,
    opacity: opts.visible ? SCRIM_OPACITY : 0,
  }
  if (!opts.reducedMotion) style.transition = `opacity ${motion.failureFadeMs}ms ease`
  return style
}
